class BritishColumbiaObstetricalFileTobacco {
    public SmokedTobaccoThreeMonthsBeforePregnancy?: boolean;
    public SmokesTobaccoDuringPregnancy?: boolean;
    public CigarettesPerDayThreeMonthsBeforePregnancy?: string;
    public CigarettesPerDayDuringPregnancy?: string;
    public WasExposedToSecondHandSmokeThreeMonthsBeforePregnancy?: boolean;
    public IsExposedToSecondHandSmokeDuringPregnancy?: boolean;
    public HasQuitTobacco?: boolean;
    public QuitTobaccoDate: Date;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileTobacco>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFileTobacco };
